import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { CalendarDayViewModel, CalendarEnabledTimes } from "../timer-calendar-view.models";

@Component({
	selector: "app-calendar-day-summary",
	templateUrl: "./calendar-day-summary.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: { class: "block h-full min-h-0 w-full" },
})
export class CalendarDaySummaryComponent {
	@Input({ required: true }) day!: CalendarDayViewModel;
	@Input({ required: true }) enabledTimes!: CalendarEnabledTimes;
}
